const KEYBOARD_VAR = '--keyboard-inset';

let bound = false;

function keyboardInsetPx(): number {
  const viewport = window.visualViewport;
  if (!viewport) {
    return 0;
  }
  const overlap = window.innerHeight - viewport.height - viewport.offsetTop;
  return overlap > 0 ? Math.round(overlap) : 0;
}

function apply(): void {
  const inset = keyboardInsetPx();
  document.documentElement.style.setProperty(KEYBOARD_VAR, `${inset}px`);
  document.querySelectorAll<HTMLElement>('[data-emitir-actions]').forEach((bar) => {
    bar.style.bottom = `calc(${inset}px + env(safe-area-inset-bottom, 0px))`;
  });
}

export function pinEmitirActionBar(): void {
  apply();
  if (bound) {
    return;
  }
  const viewport = window.visualViewport;
  if (!viewport) {
    return;
  }
  bound = true;
  viewport.addEventListener('resize', apply);
  viewport.addEventListener('scroll', apply);
  window.addEventListener('orientationchange', apply);
}
